/**
 * Simple semaphore-based concurrent request limiter.
 * Limits the number of in-flight HTTP requests to prevent server overload
 * when rendering many chart grid cells simultaneously.
 */

const DEFAULT_MAX_CONCURRENT = 6;

let activeCount = 0;
let maxConcurrent = DEFAULT_MAX_CONCURRENT;
const waitQueue: Array<() => void> = [];

export function setMaxConcurrent(n: number) {
  maxConcurrent = Math.max(1, n);
}

export function acquire(): Promise<void> {
  if (activeCount < maxConcurrent) {
    activeCount++;
    return Promise.resolve();
  }
  return new Promise<void>((resolve) => {
    waitQueue.push(() => {
      activeCount++;
      resolve();
    });
  });
}

export function release(): void {
  activeCount--;
  if (waitQueue.length > 0 && activeCount < maxConcurrent) {
    const next = waitQueue.shift();
    next?.();
  }
}
